import { Controller } from "@hotwired/stimulus"

import Sortable from "sortablejs"

export default class extends Controller {
  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return
    this.sortable = Sortable.create(this.element, { onEnd: event => this.save(event) })
  }

  disconnect() {
    this.teardown()
  }

  teardown() {
    this.sortable?.destroy()
    this.sortable = null
  }

  save({ item, newIndex }) {
    const body = new FormData()
    body.append("guide[position]", newIndex)
    fetch(`/guide/${item.dataset.guide}`, {
      method: "PATCH",
      headers: { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content },
      body
    })
  }
}
